import { Controller } from '@hotwired/stimulus'

// Narrows the tag chips already on the page.
//
// Nothing here talks to the server: the rail renders every chip into the HTML, so the search is
// a function of bytes the visitor already has. That is the whole security story — no endpoint,
// no query, no rate limit, because there is no request. Same reasoning as
// `specialization-search-controller.js`, which does this for the mobile panel.
export default class extends Controller {
  static targets = ['input', 'empty']

  connect () {
    // A filter change re-renders the rail; start from an unfiltered list every time.
    this.filter()
  }

  filter () {
    const query = this.hasInputTarget ? this.inputTarget.value.trim().toLowerCase() : ''
    let visible = 0

    for (const chip of this.#chips()) {
      // includes(), never a RegExp built from the query: `new RegExp('(')` throws — a visitor
      // typing "C++ (senior)" would break their own search — and a pattern a stranger supplies
      // is the standard way to hand them our CPU.
      const match = query === '' || chip.textContent.toLowerCase().includes(query)

      chip.hidden = !match
      if (match) visible += 1
    }

    this.#revealFolds(query)

    if (this.hasEmptyTarget) this.emptyTarget.hidden = query === '' || visible > 0
  }

  // The search box lives inside the filter form, which submits on `change`. Without this a
  // visitor who typed and then clicked away would reload the board for a value the server has
  // no use for.
  swallow (event) {
    event.stopPropagation()
  }

  // A matching chip must be findable, and past the first few they start inside a closed
  // <details>. Opening the fold while searching is the only thing here that touches anything
  // but `hidden`; an empty query puts every fold back the way the page rendered it.
  #revealFolds (query) {
    for (const fold of this.element.querySelectorAll('[data-rail-type="specialization"] details.rail-more')) {
      if (query === '') {
        fold.open = false
        continue
      }

      fold.open = [...fold.querySelectorAll('label.rail-chip')].some(chip => !chip.hidden)
    }
  }

  // The LABEL, not the checkbox inside it: the label is the chip, it carries the text, and it is
  // what has to disappear. Tag sections only — the box says "find a tag", and hiding a job type
  // or a company behind it would be a different, unasked-for feature.
  #chips () {
    return this.element.querySelectorAll('[data-rail-type="specialization"] label.rail-chip')
  }
}
